import { LayoutDashboard, Building2, Target, LogOut, Ticket, UserCheck, Wallet, Stethoscope } from "lucide-react";

const NAV = [
  { id: "overview", label: "Visão Geral", icon: LayoutDashboard },
  { id: "customers", label: "Clientes Ativos", icon: Building2 },
  { id: "activations", label: "Ativações", icon: UserCheck },
  { id: "doctors", label: "Médicos & Clínicas", icon: Stethoscope },
  { id: "repasses", label: "Repasses", icon: Wallet },
  { id: "crm", label: "CRM & Vendas", icon: Target },
  { id: "coupons", label: "Cupons", icon: Ticket },
];

export const Sidebar = ({ active, onChange, onLogout, userEmail }) => (
  <aside className="flex w-full shrink-0 flex-col bg-slate-900 text-slate-300 lg:min-h-screen lg:w-64" data-testid="bo-sidebar">
    <div className="flex items-center justify-between px-6 py-5 lg:py-6">
      <div className="flex items-center gap-2.5">
        <img src="/veloclin-logo.png" alt="VeloClin" data-testid="brand-logo" className="h-10 w-auto rounded-full bg-white p-0.5" />
        <p className="text-[10px] font-medium uppercase tracking-wider text-slate-500">Backoffice</p>
      </div>
      <button
        data-testid="bo-logout-btn-mobile"
        onClick={onLogout}
        className="flex items-center gap-1.5 rounded-lg px-2.5 py-1.5 text-xs font-medium text-slate-400 hover:bg-rose-500/10 hover:text-rose-300 lg:hidden"
      >
        <LogOut className="h-4 w-4" /> Sair
      </button>
    </div>

    <nav className="flex gap-1 overflow-x-auto px-3 pb-3 lg:mt-2 lg:flex-1 lg:flex-col lg:space-y-1 lg:overflow-visible lg:pb-0">
      {NAV.map(({ id, label, icon: Icon }) => {
        const isActive = active === id;
        return (
          <button
            key={id}
            data-testid={`bo-nav-${id}`}
            onClick={() => onChange(id)}
            className={`flex shrink-0 items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-medium transition-colors lg:w-full ${
              isActive ? "bg-white/10 text-white" : "text-slate-400 hover:bg-white/5 hover:text-white"
            }`}
          >
            <Icon className="h-4 w-4" strokeWidth={2.2} />
            {label}
          </button>
        );
      })}
    </nav>

    <div className="hidden border-t border-white/5 p-3 lg:block">
      <div className="mb-2 truncate px-3 py-1 text-[11px] text-slate-500">{userEmail}</div>
      <button
        data-testid="bo-logout-btn"
        onClick={onLogout}
        className="flex w-full items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-medium text-slate-400 transition-colors hover:bg-rose-500/10 hover:text-rose-300"
      >
        <LogOut className="h-4 w-4" strokeWidth={2.2} />
        Sair
      </button>
    </div>
  </aside>
);
